import { Component, Inject, OnInit } from '@angular/core';
import { UtilsService } from '../../../shared/utils.service';
import { AppService } from '../../../app.service';
import { AssetsService } from '../../assets.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  NetworkedAccountsSelectorComponent
} from '../../../shared/networked-accounts-selector/networked-accounts-selector.component';
import { VendorsSelectorComponent } from '../../../shared/vendors-selector/vendors-selector.component';
import {
  NetworkedUsersSelectorComponent
} from '../../../shared/networked-users-selector/networked-users-selector.component';
import { AssetMaintenanceSchedulesFilters } from './asset-maintenance-schedules-filter.interface';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { AssetMaintenanceRecordsService } from '../../asset-maintenance-records/asset-maintenance-records.service';

@Component({
  selector: 'app-asset-maintenance-schedules-filter',
  templateUrl: './asset-maintenance-schedules-filter.component.html',
  styleUrls: ['./asset-maintenance-schedules-filter.component.scss']
})
export class AssetMaintenanceSchedulesFilterComponent implements OnInit {
  filters: AssetMaintenanceSchedulesFilters = {
    archived: 'false',
    contractor_ids: [],
    vendor_ids: [],
    user_ids: [],
    maintenance_type: 'all',
    default_priority: 'all',
    enabled: 'all',
    is_recurring: 'all',
    auto_create: 'all',
    date_type: 'next_due_at',
    date_range: []
  };

  maintenanceTypeOptions = this.utils.toOptions(this.assetMaintenanceRecordsService.TYPES);
  priorityOptions = this.utils.toOptions(this.assetMaintenanceRecordsService.PRIORITIES);

  faHardHat = faHardHat;

  constructor(
    public utils: UtilsService,
    public app: AppService,
    public assetsService: AssetsService,
    public assetMaintenanceRecordsService: AssetMaintenanceRecordsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetMaintenanceSchedulesFilterComponent>
  ) {}

  ngOnInit() {
    this.filters.archived = this.data['archived'] || 'false';
    this.filters.contractor_ids = this.data['contractor_ids'] || [];
    this.filters.vendor_ids = this.data['vendor_ids'] || [];
    this.filters.user_ids = this.data['user_ids'] || [];
    this.filters.maintenance_type = this.data['maintenance_type'] || 'all';
    this.filters.default_priority = this.data['default_priority'] || 'all';
    this.filters.enabled = this.data['enabled'] || 'all';
    this.filters.is_recurring = this.data['is_recurring'] || 'all';
    this.filters.auto_create = this.data['auto_create'] || 'all';
    this.filters.date_type = this.data['date_type'] || 'next_due_at';
    this.filters.date_range = this.data['date_range'] || [];
  }

  /**
   * Sets the output date range based on the provided event value.
   *
   * @param event
   * @return {void} - No return value.
   */
  getOutputDateRange(event: any): void {
    this.filters.date_range = event;
  }

  /**
   * Select contractors and update the contractor IDs filters.
   *
   * @return {void}
   */
  onSelectContractors(): void {
    this.utils.showComponentDialog(
      NetworkedAccountsSelectorComponent,
      {
        selected: this.filters.contractor_ids,
        multiple: true
      },
      {
        width: '1200px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.contractor_ids = results;
      }
    );
  }

  /**
   * Select vendors and update the vendor IDs filters.
   *
   * @return {void}
   */
  onSelectVendors(): void {
    this.utils.showComponentDialog(
      VendorsSelectorComponent,
      {
        selected: this.filters.vendor_ids,
        multiple: true,
        required: false
      },
      {
        width: '1200px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.vendor_ids = results;
      }
    );
  }

  /**
   * Select networked users and update the user IDs filters.
   *
   * @return {void}
   */
  onSelectUsers(): void {
    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      {
        selected: this.filters.user_ids,
        multiple: true,
        selectedAccountId: this.app.account.id,
        visitors_from_all_sites: true
      },
      {
        width: '1200px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.user_ids = results;
      }
    );
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    this.filters.archived = 'false';
    this.filters.contractor_ids = [];
    this.filters.vendor_ids = [];
    this.filters.user_ids = [];

    this.filters.maintenance_type = 'all';
    this.filters.default_priority = 'all';

    this.filters.enabled = 'all';
    this.filters.is_recurring = 'all';
    this.filters.auto_create = 'all';
    this.filters.date_type = 'next_due_at';
    this.filters.date_range = [];

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Clears the date range for this filter.
   *
   * @return {void}
   */
  onClearDateRange(): void {
    this.filters.date_range = [];
  }
}
